export default __webpack_public_path__ + "success.74923958.svg";